import { clsx } from 'clsx';
import { RefreshCw } from 'lucide-react';

interface ScrapeButtonProps {
  hasData: boolean;
  summary?: string;
  creditCost: number;
  onScrape: () => void;
  onRescrape: () => void;
  onViewData: () => void;
  disabled?: boolean;
  unavailable?: boolean;
  unavailableReason?: string;
}

export function ScrapeButton({
  hasData,
  summary,
  creditCost,
  onScrape,
  onRescrape,
  onViewData,
  disabled,
  unavailable,
  unavailableReason,
}: ScrapeButtonProps) {
  if (unavailable) {
    return (
      <span
        className="text-xs text-gray-500 cursor-help"
        title={unavailableReason}
      >
        N/A
      </span>
    );
  }

  if (hasData) {
    return (
      <div className="flex items-center gap-1">
        <button
          onClick={onViewData}
          className="px-2 py-1 rounded text-xs font-medium bg-green-500 text-white hover:bg-green-600 transition-colors"
        >
          {summary || '✓'}
        </button>
        <button
          onClick={onRescrape}
          className="text-gray-500 hover:text-blue-400 text-xs p-1"
          title={`Refresh data (${creditCost} cr)`}
        >
          <RefreshCw className="w-3 h-3" />
        </button>
      </div>
    );
  }

  return (
    <button
      onClick={onScrape}
      disabled={disabled}
      className={clsx(
        'px-2 py-1 rounded text-xs font-medium transition-all',
        'bg-gradient-to-br from-indigo-500 to-indigo-700',
        'hover:from-indigo-400 hover:to-indigo-600',
        'disabled:from-gray-600 disabled:to-gray-700 disabled:cursor-not-allowed',
        'text-white'
      )}
    >
      {creditCost} cr
    </button>
  );
}
